module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-friend-1-large-45f47377e9db4ecdf160521b926a3da3.jpg";